<template>
  <div>
    <!--<p>
      {{ this.$store.getters.calcStep }} - {{ this.$store.getters.calcStatus }} -
      {{ !!this.$store.getters.status_NonConfigurato }}
    </p>
    <p v-if="offerEditMode">
      offerId: {{ $route.params.offerId }} offerRowId: {{ $route.params.offerRowId }}
    </p>-->
    <Loading :active="bShowLoading" :is-full-page="true"></Loading>
    <div v-if="project && project.path" class="project-container animated fadeIn">
      <!-- container-fluid -->
      <div v-show="preprintViewHidden && warningsViewHidden" class="row">
        <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
        <div class="col-xl-3 col-lg-12">
          <PheProjectAdvancedDetails
            v-if="verifyView || selectionView || selectionOutputView"
            ref="shoulderComponent"
            :parent-path="project.path"
            :local-path="'.shoulder'"
          ></PheProjectAdvancedDetails>
          <keep-alive> </keep-alive>
        </div>
        <!-- == MODIFICHE DA LASCIARE DIVERSE == -->
        <div class="col-xl-9 col-lg-12">
          <div class="row">
            <div class="col-12">
              <CapacityDetails :parent-path="project.path" :local-path="'.top'"></CapacityDetails>
              <keep-alive> </keep-alive>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-6 col-lg-12" style="margin-bottom: 24px;">
              <MonoPhasePheDetails
                :parent-path="project.path"
                :local-path="'.left'"
              ></MonoPhasePheDetails>
              <keep-alive> </keep-alive>
            </div>
            <div class="col-xl-6 col-lg-12" style="margin-bottom: 24px;">
              <component
                :is="rightComponent"
                :parent-path="project.path"
                :local-path="'.right'"
              ></component>
              <keep-alive> </keep-alive>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <PheProjectDetails
                v-if="verifyView"
                :parent-path="project.path"
                :local-path="'.bottom'"
              ></PheProjectDetails>
              <PheProjectSelectionDetails
                v-show="selectionView"
                :parent-path="project.path"
                :local-path="'.bottomSelection'"
              ></PheProjectSelectionDetails>
              <!-- <PheSelectionOutput /> -->
              <keep-alive> </keep-alive>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectionOutputView && warningsViewHidden" class="row" style="margin-top: 30px; ">
        <div class="col-12">
          <PheProjectSelectionOutput
            v-if="selectionOutputView"
            ref="gridSel"
            :parent-path="project.path"
            :local-path="'.selectionOutput'"
            @passaInVerifica="passaInVerifica"
            @selectProject="selectProject"
          ></PheProjectSelectionOutput>
        </div>
      </div>
      <div v-if="!preprintViewHidden">
        <PheAccessoriesCipriani ref="gestioneAccessori" :parent-path="project.path" />
      </div>
      <div v-if="!warningsViewHidden" class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <WarningsPanel
                :parent-path="project.path"
                :local-path="'.shoulder'"
                :warnings="warningsList"
              ></WarningsPanel>
              <keep-alive> </keep-alive>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="pannelloWarning" size="xl" centered hide-backdrop hide-header>
        <WarningsPanel
          :parent-path="project.path"
          :local-path="'.shoulder'"
          :warnings="warningsList"
        ></WarningsPanel>

        <template #modal-footer>
          <b-button
            :style="{
              backgroundColor: coloreFooterBottoni,
              borderColor: coloreBordoBottoni,
              color: coloreTestoBottoni
            }"
            size="sm"
            type="button"
            class="btn btn-default float-right"
            @click="pannelloWarning = false"
          >
            {{ uniTranslation("PHE20282") }}
          </b-button>
          <b-button
            v-show="bAskToContinue"
            :style="{
              backgroundColor: coloreFooterBottoni,
              borderColor: coloreBordoBottoni,
              color: coloreTestoBottoni
            }"
            size="sm"
            type="button"
            class="btn btn-default float-right"
            @click="calculate"
          >
            {{ uniTranslation("PHE20281") }}
          </b-button>
        </template>
      </b-modal>
    </div>

    <!-- SAVE -->
    <saveProject
      :title="uniTranslation('S698')"
      :dialog-visible="saveProjectDialogVisible"
      :show-project-name="true"
      :project="project"
      :enable-save-project="true"
      :enable-save-project-as="true"
      :mandatory-fields="true"
      @closeDialog="afterSaveProjectDialogVisible"
    >
    </saveProject>

    <!-- ADD TO OFFER -->
    <saveProject
      :title="uniTranslation('S698')"
      :dialog-visible="showAddToOfferSave"
      :show-project-name="false"
      :project="project"
      :enable-save-project="false"
      :enable-save-project-as="false"
      :show-customer-selection="false"
      :save-button-label="'GON99'"
      :mandatory-fields="true"
      @closeDialog="afterShowAddToOfferSelect"
    >
    </saveProject>

    <!-- REPLACE IN OFFER -->
    <saveProject
      :title="uniTranslation('S698')"
      :dialog-visible="showReplaceInOfferSave"
      :show-project-name="false"
      :project="project"
      :enable-save-project="false"
      :enable-save-project-as="false"
      :show-customer-selection="false"
      :save-button-label="'PHE10274'"
      :mandatory-fields="true"
      @closeDialog="afterShowReplaceInOfferSelect"
    >
    </saveProject>

    <!-- PRINT "'Set print data'" -->
    <!-- SELEZIONE-->
    <saveProject
      :title="uniTranslation('PHE20002')"
      :dialog-visible="preExchangerPrint"
      :show-project-name="false"
      :project="project"
      :enable-save-project="false"
      :enable-save-project-as="false"
      :show-customer-selection="true"
      :mandatory-fields="false"
      :save-button-label="'PHE10212'"
      @closeDialog="afterPreExchangerPrint"
    >
    </saveProject>

    <div
      class="project-footer"
      :style="{
        backgroundColor: coloreFooterSfondo,
        color: coloreFooterTesto,
        borderColor: coloreFooterSfondo
      }"
      style="z-index:1018"
    >
      <div class="main">
        <!-- PULSANTE_BACK_PRE_PRINT -->
        <button
          v-if="!preprintViewHidden"
          id="PULSANTE_BACK_PRE_PRINT"
          v-tooltip="{ content: uniToolTipTranslation('GO026', 'en-US'), placement: 'right' }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn btn-default"
          @click="subViewToggle('togglePrePrintViewProperty')"
        >
          <!-- @click="printProject" -->
          <i class="fa fa-arrow-left"></i>
          {{ uniTranslation("GO026") }}
          <!-- # # # PRE-PRINT -->
        </button>
        <!-- PULSANTE_BACK_TO_BEFORE_SELECTION-->
        <button
          v-if="
            preprintViewHidden &&
              selectionOutputView &&
              warningsViewHidden &&
              !isSelezionePreCalcolo
          "
          id="PULSANTE_BACK_TO_BEFORE_SELECTION"
          v-tooltip="{ content: uniToolTipTranslation('GO026', 'en-US'), placement: 'right' }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn btn-default"
          @click="returnToBeforeSelection()"
        >
          <!-- @click="printProject" -->
          <i class="fa fa-arrow-left"></i>
          {{ uniTranslation("GO026") }}
          <!-- # # # BEFORE SELECTION -->
        </button>
        <!-- PULSANTE_BACK_TO_SELETION_LIST -->
        <button
          v-if="isSelezionePreCalcolo && preprintViewHidden && warningsViewHidden"
          id="PULSANTE_BACK_TO_SELETION_LIST"
          v-tooltip="{ content: uniToolTipTranslation('GO026', 'en-US'), placement: 'right' }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn btn-default"
          @click="returnToSelectionList()"
        >
          <!-- @click="printProject" -->
          <i class="fa fa-arrow-left"></i>
          {{ uniTranslation("GO026") }}
          <!-- # # # TO SELECTION -->
        </button>
        <!-- PULSANTE_BACK_DAI_WARNING -->
        <button
          v-if="!warningsViewHidden"
          id="PULSANTE_BACK_DAI_WARNING"
          v-tooltip="{
            content: uniToolTipTranslation('S106', 'en-US'),
            placement: 'right'
          }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn-print-project btn btn-default"
          @click="backWarnings()"
        >
          <i class="fa fa-arrow-left"></i>
          {{ uniTranslation("S106") }}
          <!-- # # # WARNINGS -->
        </button>
        <!-- PULSANTE_WARNING -->
        <!-- Marco B Commentato su loro richiesta in data 25/09/2020
          <button
          v-if="
            (bHasWarnings || bHasBlockingWarnings) &&
              warningsViewHidden &&
              !$store.getters.status_PreCalcolo
          "
          id="PULSANTE_WARNING"
          v-tooltip="{
            content: uniTranslation('S954', 'en-US'),
            placement: 'right'
          }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn-print-project btn btn-default"
          @click="subViewToggle('toggleWarningsViewProperty')"
        >
          <i class="fa fa-warning"></i>
          {{ uniTranslation("S954") }}
          <!- # # # WARNINGS ->
        </button>-->
        <!-- PULSANTE_WARNING (CON MODALE) -->
        <button
          v-if="
            (bHasWarnings || bHasBlockingWarnings) &&
              warningsViewHidden &&
              !$store.getters.status_PreCalcolo
          "
          id="PULSANTE_WARNING"
          v-tooltip="{
            content: uniToolTipTranslation('S954', 'en-US'),
            placement: 'right'
          }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn-print-project btn btn-default"
          @click="showWarningsModal()"
        >
          <i class="fa fa-warning"></i>
          {{ uniTranslation("S954") }}
          <!-- # # # WARNINGS -->
        </button>
        <!-- PULSANTE_IGNORA_WARNING_E_CONTINUA_CON_IL_CALCOLO -->
        <button
          v-if="bHasWarnings && bAskToContinue && !warningsViewHidden"
          id="PULSANTE_IGNORA_WARNING_E_CONTINUA_CON_IL_CALCOLO"
          v-tooltip="{
            content: uniToolTipTranslation('S2322', 'en-US'),
            placement: 'right'
          }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn-print-project btn btn-default"
          @click="ignoreWarningRecalculateProject()"
        >
          <i class="fa fa-check"></i>
          {{ uniTranslation("GO027") }}
          <!-- # # # IGNORA WARNINGS -->
        </button>

        <!-- PULSANTE_NEXT_Stampa -->
        <button
          v-if="calculated && !preprintViewHidden && warningsViewHidden"
          id="PULSANTE_NEXT_Stampa"
          v-tooltip="{ content: uniToolTipTranslation('GO027', 'en-US'), placement: 'left' }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn btn-default pull-right"
          :disabled="waitDoneOperation"
          @click="setConfiguredAndPrint"
        >
          <!-- @click="printProject" -->
          <i class="fa fa-print"></i>
          {{ uniTranslation("GO027") }}
          <!-- # # # CONFIGURATO -->
        </button>
        <!-- PULSANTE_NEXT_Da_Configurare -->
        <button
          v-if="
            calculated &&
              !configured &&
              preprintViewHidden &&
              warningsViewHidden &&
              !selectionOutputView
          "
          id="PULSANTE_NEXT_Da_Configurare"
          v-tooltip="{ content: uniToolTipTranslation('GO027', 'en-US'), placement: 'left' }"
          :disabled="bDisableNext || bDisableNextDaSpalla"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn btn-default pull-right"
          @click="sincronizzaSpalla"
        >
          <!-- @click="printProject" -->
          {{ uniTranslation("GO027") }}
          <!-- # # # DA CONFIGURARE -->
          <i class="fa fa-arrow-right"></i>
        </button>
        <!-- PULSANTE_SOSTITUISCI_IN_OFFERTA -->
        <button
          v-show="
            calculated &&
              !preprintViewHidden &&
              !offerEditMode &&
              (this.$store.getters.getIdOffertaAttiva || isOpenFromOffer())
          "
          id="PULSANTE_SOSTITUISCI_IN_OFFERTA"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn btn-default pull-right"
          :disabled="waitDoneOperation"
          @click="replaceInOffer"
        >
          <i class="fa fa-money"></i>
          {{ uniTranslation("PHE10274") }}
        </button>
        <!-- PULSANTE_AGGIUNTI_IN_OFFERTA -->
        <button
          v-show="calculated && !preprintViewHidden && !offerEditMode"
          id="PULSANTE_AGGIUNTI_IN_OFFERTA"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn btn-default pull-right"
          :disabled="waitDoneOperation"
          @click="addToOffer"
        >
          <i class="fa fa-money"></i>
          {{ uniTranslation("GON99") }}
        </button>
        <!-- PULSANTE_Esporta_Griglia_Selezione -->
        <button
          v-if="calculated && selectionOutputView"
          id="PULSANTE_Esporta_Griglia_Selezione"
          v-tooltip="{ content: uniToolTipTranslation('PHE2231', 'en-US'), placement: 'left' }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn btn-default pull-right"
          @click="exportSelectionGrid"
        >
          <!-- @click="printProject" -->
          <i class="fa fa-file-excel-o"></i>
          {{ uniTranslation("PHE2231") }}
          <!-- # # # CONFIGURATO -->
        </button>

        <!-- PULSANTE_CALCULATE -->
        <button
          v-if="warningsViewHidden && preprintViewHidden"
          id="PULSANTE_CALCULATE"
          v-tooltip="{ content: uniToolTipTranslation('S102', 'en-US'), placement: 'left' }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          :disabled="disableCalcolate"
          type="button"
          class="btn btn-default pull-right"
          @click="recalculateProject"
        >
          <i :class="calcIcon"></i>
          <!--class="fa fa-calculator"-->
          {{ uniTranslation("S102") }}
        </button>
        <!-- PULSANTE_SALVA -->
        <button
          v-show="(calculated && !preprintViewHidden) || saved"
          id="PULSANTE_SALVA"
          v-tooltip="{ content: uniToolTipTranslation('S332', 'en-US'), placement: 'left' }"
          :style="{
            backgroundColor: coloreFooterBottoni,
            borderColor: coloreBordoBottoni,
            color: coloreTestoBottoni
          }"
          type="button"
          class="btn btn-default pull-right"
          :disabled="waitDoneOperation"
          @click="saveProjectDialogVisible = true"
        >
          <i class="fa fa-save"></i>
          {{ uniTranslation("S332") }}
        </button>
      </div>
      <b-modal
        v-model="showAddToOfferSelect"
        :title="uniTranslation('GON99')"
        size="xl"
        scrollable
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
      >
        <b-row>
          <b-col align="center">
            <b-button
              :style="{
                backgroundColor: coloreFooterBottoni,
                borderColor: coloreBordoBottoni,
                color: coloreTestoBottoni
              }"
              style="margin: 5px"
              size="lg"
              :disabled="creazioneOffertaInCorso"
              @click="showNewOffer"
              >{{ uniTranslation("PHE140") }}</b-button
            >
            <b-button
              :style="{
                backgroundColor: coloreFooterBottoni,
                borderColor: coloreBordoBottoni,
                color: coloreTestoBottoni
              }"
              style="margin: 5px"
              size="lg"
              :disabled="creazioneOffertaInCorso"
              @click="setShowAddToExistingOffer"
              >{{ uniTranslation("GON100") }}</b-button
            >
            <b-button
              v-show="this.$store.getters.getIdOffertaAttiva"
              :style="{
                backgroundColor: coloreFooterBottoni,
                borderColor: coloreBordoBottoni,
                color: coloreTestoBottoni
              }"
              style="margin: 5px"
              size="lg"
              :disabled="creazioneOffertaInCorso"
              @click="addOffertaAttiva"
              >{{ uniTranslation("GON103") }}</b-button
            >
          </b-col>
        </b-row>
      </b-modal>

      <b-modal
        v-model="showAddToExistingOffer"
        :title="uniTranslation('GON101')"
        size="xl"
        scrollable
        @ok="addProjectToExistingOffer"
      >
        <template v-slot="offerManagement">
          <OfferManagement
            id="om"
            :from-add-to-offer="true"
            @changeIdSelectedOffer="setRicordaOffertaSelezionata"
          ></OfferManagement>
        </template>
      </b-modal>

      <b-modal
        v-model="bshowNewOffer"
        :title="uniTranslation('GON102')"
        size="xl"
        scrollable
        :hide-footer="!newOfferSaved"
        ok-only
        @show="newOfferSaved = false"
      >
        <template v-slot="offerEdit">
          <OfferEdit
            id="oe"
            :from-add-to-offer="true"
            :id-selected-offer="ricordaIdSelectedOffer"
            @saved="newOfferSaved = true"
          ></OfferEdit>
        </template>
      </b-modal>

      <b-modal
        v-model="showReplaceInOfferSelect"
        :title="uniTranslation('PHE10274')"
        size="xl"
        scrollable
        :hide-footer="!replaceDone"
        ok-only
        @show="replaceDone = false"
      >
        <template v-slot="offerEdit">
          <OfferEdit
            id="oe"
            :modalita-replace="true"
            :from-add-to-offer="false"
            :id-selected-offer="$store.getters.getIdOffertaAttiva"
            :replace-calc-id="replaceCalcId"
            @saved="replaceDone = true"
          ></OfferEdit>
        </template>
      </b-modal>

      <b-modal v-model="offertaSostituita" hide-footer hide-header no-close-on-backdrop>
        <div class="d-block text-center">
          <h4>
            <b-row>
              <b-col sm="2">
                <i class="fa fa-check-square" style="color: green" aria-hidden="true"></i>
              </b-col>
              <b-col sm="8">
                {{ $t("SOSTITUZIONECOMPLETATA") }}
              </b-col>
              <b-col sm="2">
                <i class="fa fa-check-square" style="color: green" aria-hidden="true"></i>
              </b-col>
            </b-row>
          </h4>
        </div>
        <b-row>
          <b-col sm="4"> </b-col>
          <b-col sm="4">
            <b-button
              :style="{
                backgroundColor: coloreFooterBottoni,
                borderColor: coloreBordoBottoni,
                color: coloreTestoBottoni
              }"
              block
              @click="nascondiModaleOffertaSostituita"
              >{{ $t("OK") }}</b-button
            >
          </b-col>
          <b-col sm="4"> </b-col>
        </b-row>
      </b-modal>
    </div>
  </div>
</template>

<!-- UnilabReport/ReportView/ReportViewerView -->

<script>
import Cookies from "js-cookie";
import store from "../../store";
import { mapGetters } from "vuex";
import { Notification /*, Message*/ } from "element-ui";
import { Dialog, Form, FormItem, Input, Button } from "element-ui";
import { MessageBox } from "element-ui";
import { Loading as loading2 } from "element-ui";

// import { api } from "../../gateways/unilabApi";

import PheAccessoriesCipriani from "../../components/offer_mgmt/PheAccessoriesCipriani";

import CapacityDetails from "../../components/project/CapacityDetails.vue";
import SteamDetails from "../../components/project/SteamDetails.vue";
import MonoPhasePheDetails from "../../components/project/MonoPhasePheDetails.vue";

import PheProjectDetails from "../../components/project/PheProjectDetails.vue";
import PheProjectAdvancedDetails from "../../components/project/PheProjectAdvancedDetails.vue";
import PheProjectSelectionDetails from "../../components/project/PheProjectSelectionDetails.vue";
import PheProjectSelectionOutput from "../../components/project/PheProjectSelectionOutput.vue";

import WarningsPanel from "../../components/shared/WarningsPanel.vue";

import projectService from "../../services/backend/projectService";
import layoutService from "../../services/backend/layoutService";
import colorsService from "../../services/backend/colorsService";
import generalservice from "../../services/backendCipriani/generalService";

import OfferEdit from "@/views/OfferManagement/OfferEdit";
import offerteservice from "@/services/backend/offersService";
import OfferManagement from "@/views/OfferManagement/OfferManagement";

//import jsonHelper from "../../shared/jsonHelper";

import saveProject from "@/views/SaveProject/SaveProject.vue";
import ProjectViewDebugger from "../../components/project/ProjectViewDebugger.vue";

import * as statuses from "../../store/modules/projectStore_Constants";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

String.prototype.replaceAll = function(search, replacement) {
  var target = this;
  return target.replace(new RegExp(search, "g"), replacement);
};

export default {
  components: {
    CapacityDetails,
    SteamDetails,
    PheProjectDetails,
    PheProjectAdvancedDetails,
    PheProjectSelectionDetails,
    PheProjectSelectionOutput,
    WarningsPanel,
    MessageBox,
    MonoPhasePheDetails,
    "el-dialog": Dialog,
    "el-form": Form,
    "el-form-item": FormItem,
    "el-input": Input,
    "el-button": Button,
    PheAccessoriesCipriani,
    OfferEdit,
    OfferManagement,
    saveProject,
    ProjectViewDebugger,
    Loading
    //loading2
  },
  data() {
    return {
      calcIcon: "fa fa-calculator",
      coloreFooterSfondo: "",
      coloreFooterTesto: "",
      coloreFooterBottoni: "",
      coloreTestoBottoni: "",
      coloreBordoBottoni: "",
      coloreBordo: "",
      project: {
        name: "",
        projectId: "",
        type: null,
        panels: null,
        modality: 0,
        path: "",
        title: "",
        description: ""
      },

      preprintViewHidden: true,
      warningsViewHidden: true,

      configured: false,

      bDisableNext: true,

      bHasWarnings: false,
      bHasBlockingWarnings: false,
      bAskToContinue: false,
      warningsList: [],
      saveProjectDialogVisible: false,
      preExchangerPrint: false,
      showAddToOfferSelect: false,
      showReplaceInOfferSelect: false,
      replaceDone: false,
      bshowNewOffer: false,
      ricordaIdSelectedOffer: 0,
      showAddToExistingOffer: false,
      unsubscribes: [],
      saved: false,
      showAddToOfferSave: false,
      showReplaceInOfferSave: false,
      replaceCalcId: "",

      bShowLoading: false,

      topComponent: "",
      leftComponent: "",
      rightComponent: "",
      bottomComponent: "",
      bottomDesignComponent: "",
      bottomSelectionComponent: "",
      outputSelectionComponent: "",
      shoulderComponent: "",
      shoulderDesignComponent: "",
      shoulderSelectionComponent: "",

      newOfferSaved: false,
      waitDoneOperation: false,
      pannelloWarning: false,
      compName: "CustomerManagement",

      offertaSostituita: false,
      creazioneOffertaInCorso: false
    };
  },
  computed: {
    ...mapGetters(["projects", "disableCalcolate", "projectsWindows"]),
    calculated() {
      return this.$store.getters.status_PostCalcolo;
    },
    verifyView() {
      return this.$store.getters.status_Verifica;
    },
    selectionView() {
      return this.$store.getters.status_Selezione && !this.$store.getters.status_PostCalcolo;
    },
    selectionOutputView() {
      return this.$store.getters.status_Selezione && this.$store.getters.status_PostCalcolo;
    },
    sidebarVisible() {
      return !this.$store.getters.sidebar;
    },
    sideMenuHidden() {
      return this.$store.getters.asideMenu;
    },
    isSelezionePreCalcolo: function() {
      return this.$store.getters.status_ArrivoDaSelezione;
    },
    bDisableNextDaSpalla: function() {
      return this.$store.getters.bDisableNextDaSpalla;
    },
    offerEditMode: function() {
      // /:offerId?/:offerRowId?
      if (this.$route.params.offerId && this.$route.params.offerRowId) return true;
      return false;
    }
  },
  watch: {
    sidebarHidden: function(/*nv, ov*/) {
      var that = this;
      setTimeout(that.handleScroll, 275);
    },
    sideMenuHidden: function(/*nv, ov*/) {
      var that = this;
      setTimeout(that.handleScroll, 275);
    }
  },
  created() {
    /*window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleScroll);*/
  },
  destroyed: function() {
    this.unsubscribes.forEach(function(u) {
      u();
    });
  },
  mounted() {
    //console.log("ProjectView");
    //console.log(this.$route.params);

    var that = this;
    that.visibleAll = false;
    //==========================================
    //MARCO DC 20/07/2021
    //Aggiunto su loro richiesta per mettere i titoli dei tab personalizzati
    document.getElementById("currentComponent").value = this.compName;
    this.impostaTitolo();

    that.$store.subscribe(function(mutation /*, state*/) {
      var comp = document.getElementById("currentComponent").value;

      if (mutation.type === "changeLanguage" && comp == that.compName) {
        that.impostaTitolo();
      }
    });
    //==========================================
    //colorsService.getColoriFooter().then(function(data) {
    var colorList = colorsService.getColoriFooter();
    //that.coloriFooter = colorList; // 3 elementi 0=sfondo 1=testo 2=bottoni
    that.coloreFooterSfondo = colorList[0];
    that.coloreFooterTesto = colorList[1];
    that.coloreFooterBottoni = colorList[2] + " !important";
    that.coloreTestoBottoni = colorList[3];
    that.coloreBordoBottoni = colorList[4];
    that.coloreBordo = colorList[5];
    //});

    that.unsubscribes.push(
      that.$store.subscribe(function(mutation) {
        if (mutation.type === "changeCalculationType") {
          that.calcModeToggle(mutation.payload);
        }
        if (mutation.type === "userInputChanged") {
          //console.log("userInputChanged");
          if (that.$store.getters.status_PostCalcolo) {
            that.$store.dispatch("ensureStatus", statuses.PRE_CALCOLO);
          }
        }
      })
    );
  },
  methods: {
    /*
      =============================================
      MARCO DC 27/07/2021
    */

    isOpenFromOffer: function() {
      var prj = this.projects["" + this.$route.params.projectId];
      return prj.idOfferta != 0 && prj.idRigaOfferta != 0;
    },
    nascondiModaleOffertaSostituita() {
      var that = this;

      that.offertaSostituita = false;
    },

    sincronizzaSpalla: function() {
      var that = this;
      that.subViewToggle("togglePrePrintViewProperty");
    },

    //=============================================

    impostaTitolo: function() {
      var prj = this.projects["" + this.$route.params.projectId];
      const title = document.getElementById("title");
      title.innerHTML = this.$t("PHETITLECALCOLO");
      if (prj) {
        if (prj.description + "" != "") title.innerHTML += " - " + prj.description;
      }
    },
    passaInVerifica() {
      //var that = this;
      // alert("passa in verifica");
      //console.log("stiamo passando in verifica");
      /*
      alert(that.project.path);

      store.dispatch("changeProjectProperty", {
        path: that.project.path + ".bottomDesign.numberOfPlates",
        value: value.numeroDiPiastre
      });
      */
    },
    returnToSelectionList() {
      //console.log("stiamo tornando indietro");
      this.$refs.shoulderComponent.returnToSelectionList();
    },
    refreshWarnings(prj) {
      var that = this;

      if (prj == undefined || prj == null) {
        prj = that.projects[that.project.projectId];
      }

      if (prj == undefined || prj == null) {
        return;
      }

      if (prj.innerProject != null) {
        that.bHasWarnings = prj.innerProject.hasWarnings; //jsonHelper.getProperty(that.projects, ""); //true; //
        that.bHasBlockingWarnings =
          prj.innerProject.hasWarningsBloccantiPreCalcolo ||
          prj.innerProject.hasWarningsBloccantiPostCalcolo;
        that.bAskToContinue = prj.innerProject.hasWarningsChiediSeContinuare;

        that.warningsList = prj.innerProject.warnings;

        // alert(that.bHasWarnings + '  -  ' + that.bHasBlockingWarnings + '  -  ' + that.bAskToContinue)

        that.bAskToContinue = false;

        if (prj.shoulder.idCalculationType != 1 || that.bHasBlockingWarnings) {
          if (that.bHasWarnings && that.bHasBlockingWarnings == false) {
            /*that.$nextTick(function() {
                Notification.warning({
                  title: that.uniTranslation("S264"),     //Marco B Commentato su loro richiesta in data 23/09/2020
                  message: that.uniTranslation("S956"),
                  offset: 100
                });
              });*/
            //that.bAskToContinue = true;
          }

          if (that.bHasBlockingWarnings) {
            that.showWarningsModal();
            //Marco B Commentato su loro richiesta in data 25/09/2020
            /*that.$nextTick(function() {
                Notification.error({
                  title: that.uniTranslation("S264"),
                  message:
                    that.uniTranslation("S956") +
                    (that.bAskToContinue ? " " + that.uniTranslation("S1786") : ""),
                  offset: 100,
                  onClick: function() {
                    this.close();
                  }
                });
              });*/
          } else if (that.bHasWarnings) {
            that.showWarningsModal();
          }
        }
      } else {
        that.bHasWarnings = false;
        that.bHasBlockingWarnings = false;
        //that.bAskToContinue = false;
        that.warningsList = [];
      }
    },

    SalvaDatiAccessori() {
      return this.$refs.gestioneAccessori.salvaDati();
    },

    addProjectToExistingOffer() {
      var that = this;

      if (this.ricordaIdSelectedOffer != 0) {
        // recupera il GUID del calcolo

        var project = that.projects;
        var prj = {};
        for (var el in project) {
          prj = project[el];
        }

        var calculationId = prj.calculationId;

        //alert(that.ricordaIdSelectedOffer);

        //alert(calculationId);

        if (calculationId) {
          // aggiunge una rigaOfferta alla offerta attiva
          offerteservice
            .addOfferRow(that.ricordaIdSelectedOffer, prj)
            .then(function(/* data */) {
              //alert(that.idNuovaOfferta);
              //a questo punto visualizzo il dettaglio offerta
              that.showAddToOfferSelect = false;
              that.bshowNewOffer = true;

              //setTimeout(() => {  //24.09.2021 => Andrea => Non capisco il timeout!!!! lo tolgo
              // imposta l'offerta attiva
              that.$store.commit("setIdOffertaAttiva", that.ricordaIdSelectedOffer);
              //}, 2000);

              that.creazioneOffertaInCorso = false;
            })
            .catch(function() {
              that.showAddToOfferSelect = false;
              that.bshowNewOffer = false;
              that.creazioneOffertaInCorso = false;
            });
        } else {
          that.creazioneOffertaInCorso = false;
        }
      } else {
        that.creazioneOffertaInCorso = false;
      }
    },
    setShowAddToExistingOffer() {
      this.showAddToOfferSelect = false;
      this.showAddToExistingOffer = true;
    },
    setRicordaOffertaSelezionata(IdSelectedOffer) {
      this.ricordaIdSelectedOffer = IdSelectedOffer;
      //alert("IdSelectedOffer => " + IdSelectedOffer);
      //alert("ricordaIdSelectedOffer => " + ricordaIdSelectedOffer);
    },
    addOffertaAttiva() {
      this.showAddToOfferSelect = false;
      this.ricordaIdSelectedOffer = this.$store.getters.getIdOffertaAttiva;
      this.addProjectToExistingOffer();
    },
    addToOffer: function() {
      //alert("aggiungere all'offerta");
      var that = this;
      that.showAddToOfferSave = true;
      /*this.SalvaDatiAccessori().then(function(data) {
        if (data != null) {
          that.UpdateProject(data);
          that.showAddToOfferSave = true;
        }
      });*/

      // disabilita pulsanti SALVE / AGGIUNGI OFFERTA / NEXT
      that.waitDoneOperation = true;
    },
    replaceInOffer: function() {
      //alert("aggiungere all'offerta");
      var that = this;
      var prj = this.projects["" + this.$route.params.projectId];
      that
        .SalvaDatiAccessori()
        .then(function(data) {
          that.showReplaceInOfferSave = prj.idOfferta == 0 || prj.idRigaOfferta == 0; //= true;

          if (that.showReplaceInOfferSave == false) {
            that.bShowLoading = true;
            offerteservice.replaceOfferRow(data).then(function() {
              setTimeout(() => {
                that.replaceDone = true;
                that.waitDoneOperation = false;
                that.offertaSostituita = true;
                that.bShowLoading = false;
              }, 2000);
            });
          }
        })
        .catch(function() {
          that.bShowLoading = false;
        });
      /*this.SalvaDatiAccessori().then(function(data) {
        if (data != null) {
          that.UpdateProject(data);
          that.showReplaceInOfferSave = true;
        }
      });*/

      // disabilita pulsanti SALVE / AGGIUNGI OFFERTA / NEXT
    },

    UpdateProject(data) {
      if (data != null && data != undefined) {
        // FIXME 191127 Da vedere se necessario, da problemi
        store.dispatch("loadProject", {
          projectId: data.projectId,
          project: data
        });
        store.dispatch("refreshAll");
      }
    },

    //ANDREA 24.09.2021 => Funzione Aggiunta da andrea Per Velocizzare
    UpdateProjectNoRefreshAll(data) {
      if (data != null && data != undefined) {
        // FIXME 191127 Da vedere se necessario, da problemi
        store.dispatch("loadProject", {
          projectId: data.projectId,
          project: data
        });
      }
    },

    CreaNuovaOfferta: function() {
      var that = this;
      this.creazioneOffertaInCorso = true;
      generalservice
        .newOffer()
        .then(function(data) {
          var offerta = data;

          //per poter usare la stessa funzione che imposta nello store l'offerta attiva
          that.ricordaIdSelectedOffer = offerta.id;
          //aggiunta dell'oggetto nella riga offerta
          that.addProjectToExistingOffer();
        })
        .catch(function() {
          that.creazioneOffertaInCorso = false;
        });
    },

    showNewOffer: function() {
      //alert("nuova offerta");
      if (this.creazioneOffertaInCorso == false) {
        this.CreaNuovaOfferta();
      }
    },
    exportSelectionGrid: function() {
      var that = this;

      var grid = that.$refs.gridSel;

      //alert(grid == null);
      grid.exportSelectionGrid();
    },
    returnToBeforeSelection() {
      this.$store.dispatch("ensureStatus", statuses.PRE_CALCOLO);
    },
    initProj(res) {
      this.project = {
        name: "",
        projectId: "",
        type: null,
        panels: null,
        modality: 0,
        path: "",
        title: "",
        description: ""
      };
      this.configured = false;
      this.topComponent = "";
      this.leftComponent = "";
      this.rightComponent = "";
      this.bottomComponent = "";
      this.bottomDesignComponent = "";
      this.bottomSelectionComponent = "";
      this.outputSelectionComponent = "";
      this.shoulderComponent = "";
      this.shoulderDesignComponent = "";
      this.shoulderSelectionComponent = "";
      this.bHasWarnings = false;
      this.bHasBlockingWarnings = false;
      this.warningsList = [];
      this.saveProjectDialogVisible = false;
      this.topComponent = layoutService.getLayoutComponent(res.panels.top);
      this.leftComponent = layoutService.getLayoutComponent(res.panels.left);
      this.rightComponent = layoutService.getLayoutComponent(res.panels.right);
      this.bottomComponent = layoutService.getLayoutComponent(res.panels.bottom);
      this.bottomDesignComponent = layoutService.getLayoutComponent(res.panels.bottomDesign);
      this.bottomSelectionComponent = layoutService.getLayoutComponent(res.panels.bottomSelection);
      this.outputSelectionComponent = layoutService.getLayoutComponent(res.panels.outputSelection);
      this.shoulderComponent = layoutService.getLayoutComponent(res.panels.shoulder);
      this.shoulderDesignComponent = layoutService.getLayoutComponent(res.panels.shoulderDesign);
      this.shoulderSelectionComponent = layoutService.getLayoutComponent(
        res.panels.shoulderSelection
      );

      this.project = {
        name: res.name,
        projectId: res.projectId,
        type: res.type,
        panels: res.panels,
        modality: res.modality,
        path: res.projectId,
        title: res.title,
        description: res.description
      };
      // this.$store.dispatch("resetSubViews");
      this.resetSubViews();
      this.$store.dispatch("changeActiveProjectModalityProperty", res.modality);

      /*
        Antonio C
        31/08/2020

        Forza l'apertura del progetto in VERIFICA
      */
      // alert(res.projectId + ".shoulder.idCalculationType");

      var m_idCalculationType = 2;

      this.$store.commit("changeCalculationType", m_idCalculationType);
      this.$store.dispatch("changeProjectProperty", {
        path: res.projectId + ".shoulder.idCalculationType",
        value: m_idCalculationType
      });

      this.$store.dispatch("ensureStatus", statuses.VERIFICA);
      //this.$store.dispatch("ensureStatus", statuses.POST_CALCOLO);

      document.getElementById("mainOverlay").setAttribute("style", "display: none;");

      document.getElementById("mainRouterView").setAttribute("style", "");
    },
    saveProject: function() {
      var that = this;
      store.dispatch("changeProjectProperty", {
        path: that.project.path + ".name",
        value: that.project.name
      });
      store.dispatch("changeProjectProperty", {
        path: that.project.path + ".title",
        value: that.project.title
      });
      store.dispatch("changeProjectProperty", {
        path: that.project.path + ".description",
        value: that.project.description
      });
      if (!that.offerEditMode) {
        // progetto non legato a offerta
        projectService.saveProject(that.projects).then(function(data) {
          if (data != undefined) {
            that.saveProjectDialogVisible = false;
            Notification.success({
              title: that.uniTranslation("S698"),
              message: that.uniTranslation("S1778")
            });
            store.dispatch("loadProject", {
              projectId: data.projectId,
              project: data
            });
            that.impostaTitolo();
          } else {
            Notification.error({
              title: that.uniTranslation("S1214"),
              message: that.uniTranslation("S1440")
            });
          }
        });
      } else {
        // progetto da offerta
        const dto = {
          projectRigaOfferta: that.projects,
          idRigaOfferta: that.$store.offerRowId
        };
        offerteservice.saveProjectOnOffer(dto).then(function(data) {
          if (data != undefined) {
            that.saveProjectDialogVisible = false;
            Notification.success({
              title: that.uniTranslation("S698"),
              message: that.uniTranslation("S1778")
            });
            store.dispatch("loadProject", {
              projectId: data.projectId,
              project: data
            });
            that.impostaTitolo();
          } else {
            Notification.error({
              title: that.uniTranslation("S1214"),
              message: that.uniTranslation("S1440")
            });
          }
        });
      }
    },
    backWarnings: function() {
      this.subViewToggle("toggleWarningsViewProperty");
      // this.$store.dispatch("ensureStatus", statuses.PRE_CALCOLO);
    },
    ignoreWarningRecalculateProject: function() {
      var that = this;
      that.bAskToContinue = false;
      that.subViewToggle("toggleWarningsViewProperty");
      that.$store.dispatch("ensureStatus", statuses.POST_CALCOLO);
    },
    recalculateProject: function() {
      var that = this;

      var canUseShoulderComponent = true; // that.$refs.shoulderComponent.canUseData;

      if (canUseShoulderComponent == false) {
        //alert(that.uniTranslation("S999"));

        Notification.error({
          title: that.uniTranslation("PHE1"),
          message: that.uniTranslation("S999")
        });
      } else {
        this.calcIcon = "fa fa-spinner fa-spin";

        let loadingInstance = loading2.service({
          lock: true,
          text: this.uniTranslation("ZZ0008"),
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
          customClass: "customSpinner"
        });

        store.dispatch("changeProjectProperty", {
          path: this.project.path + ".overrideWarnings",
          value: false
        });

        //alert("that.project.path = " + that.project.path);

        //alert("this.$store.getters.calcStep = " + this.$store.getters.calcStep);
        //alert("fromSelezione = " + fromSelezione);
        that.bDisableNext = true;
        projectService
          .checkWarningSeContinuarePreCalcolo(that.projects)
          .then(data => {
            if (data.length > 0) {
              that.warningsList = data;
              that.showWarningsModal();
              that.bAskToContinue = true;
              that.calcIcon = "fa fa-calculator";
              loadingInstance.close();
              return;
            }
            that.calculate();
          })
          .catch(() => {
            loadingInstance.close();
          });
      }
    },
    calculate() {
      var that = this;
      this.pannelloWarning = false;
      store.dispatch("changeProjectProperty", {
        path: this.project.path + ".overrideWarnings",
        value: false
      });

      let loadingInstance = loading2.service({
        lock: true,
        text: this.uniTranslation("ZZ0008"),
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "customSpinner"
      });

      var P = that.projects[that.project.path];
      var deepClone_P = JSON.parse(JSON.stringify(P));
      var clone_results = deepClone_P.results;
      var clone_selectionOutputResults = deepClone_P.selectionOutput.selectionOutput;

      var fromSelezione =
        that.$store.getters.calcStatus.includes(",POST_CALCOLO,") == true &&
        that.$store.getters.calcStatus.includes(",VERIFICA,") == true &&
        that.$store.getters.calcStatus.includes(",ARRIVO_DA_SELEZIONE,") == true;

      var that = this;
      projectService
        .recalculateProject(that.projects)
        .then(function(data) {
          //alert("calcolato!");

          that.$store.commit("bDisableNextDaSpalla", false);

          if (data != null && data != undefined) {
            // Se arrivo da una selezione ci si assicura che il progetto
            // calcolato abbia sempre la lista dei risultati della selezione
            if (fromSelezione == true) {
              data.results = clone_results;
              data.selectionOutput.selectionOutput = clone_selectionOutputResults;
            }
            store.dispatch("loadProject", {
              projectId: data.projectId,
              project: data
            });

            if (data.calculated) {
              store.dispatch("refreshAll");
              that.refreshWarnings(data);
              if (data.performSelection) {
                that.subViewToggle("toggleSelectionOutputViewProperty");
              }
              that.configured = false;

              let bHasBlockingWarnings =
                data.innerProject.hasWarningsBloccantiPreCalcolo ||
                data.innerProject.hasWarningsBloccantiPostCalcolo;

              that.bDisableNext = bHasBlockingWarnings;

              if (!bHasBlockingWarnings) {
                that.$store.dispatch("ensureStatus", statuses.POST_CALCOLO);
              }
            }

            if (!data.calculated) {
              that.refreshWarnings(data);
              let bHasBlockingWarnings =
                data.innerProject.hasWarningsBloccantiPreCalcolo ||
                data.innerProject.hasWarningsBloccantiPostCalcolo;

              that.bDisableNext = bHasBlockingWarnings;

              if (!bHasBlockingWarnings) {
                that.$store.dispatch("ensureStatus", statuses.POST_CALCOLO);
              }
            }
          }
        })
        .catch(function() {
          that.configured = false;
        })
        .finally(() => {
          loadingInstance.close();

          that.calcIcon = "fa fa-calculator";
        });
    },
    selectProject: function(indexProject) {
      this.calcIcon = "fa fa-spinner fa-spin";

      var that = this;
      store.dispatch("changeProjectProperty", {
        path: this.project.path + ".overrideWarnings",
        value: false
      });

      projectService
        .selectProject(that.projects, indexProject)
        .then(function(data) {
          that.calcIcon = "fa fa-calculator";
          if (data != null && data != undefined) {
            store.dispatch("loadProject", {
              projectId: data.projectId,
              project: data
            });
            if (data.calculated) {
              store.dispatch("refreshAll");
              that.refreshWarnings(data);
              if (data.performSelection) {
                that.subViewToggle("toggleSelectionOutputViewProperty");
              }
              that.configured = false;

              let bHasBlockingWarnings =
                data.innerProject.hasWarningsBloccantiPreCalcolo ||
                data.innerProject.hasWarningsBloccantiPostCalcolo;

              if (!bHasBlockingWarnings) {
                that.$store.dispatch("ensureStatus", statuses.POST_CALCOLO);
              }
            }
          }
        })
        .catch(function() {
          that.calcIcon = "fa fa-calculator";
          that.configured = false;
        });
    },
    setConfiguredAndPrint: function() {
      //alert("sono qui");

      // disabilita il pulsante PRINT (NEXT) per evitare
      // richiesta multiple di stampa
      this.waitDoneOperation = true;

      this.preExchangerPrint = true;
    },
    afterPreExchangerPrint: function(result) {
      var that = this;
      this.preExchangerPrint = false;
      if (result) {
        that
          .SalvaDatiAccessori()
          .then(function(data) {
            if (data != null) {
              that.configured = true;
              that.UpdateProject(data);
              that.subViewToggle("togglePrePrintViewProperty");
              that.printProject();
              that.subViewToggle("togglePrePrintViewProperty");

              // riabilitazione pulsante PRINT (NEXT)
              that.waitDoneOperation = false;
            }
          })
          .catch(error => {
            // riabilitazione pulsante PRINT (NEXT)
            that.waitDoneOperation = false;
          });
      } else {
        // riabilitazione pulsante PRINT (NEXT)
        that.waitDoneOperation = false;
      }
    },
    afterShowAddToOfferSelect: function(result) {
      var that = this;
      that.showAddToOfferSave = false;
      //console.log(result);
      if (result) {
        that
          .SalvaDatiAccessori()
          .then(function(data) {
            if (data != null) {
              //that.UpdateProject(data);
              that.UpdateProjectNoRefreshAll(data);
              that.showAddToOfferSelect = true;
              that.creazioneOffertaInCorso = false;
              that.waitDoneOperation = false;
            }
          })
          .catch(error => {
            // riabilitazione pulsante PRINT (NEXT)
            that.waitDoneOperation = false;
          });
      } else {
        that.waitDoneOperation = false;
      }
    },
    afterShowReplaceInOfferSelect: function(result) {
      var that = this;
      that.showReplaceInOfferSave = false;

      if (result) {
        that
          .SalvaDatiAccessori()
          .then(function(data) {
            if (data != null) {
              that.UpdateProject(data);
              setTimeout(() => {
                // recupera il GUID del calcolo
                var project = that.projects;
                var prj = {};
                for (var el in project) {
                  prj = project[el];
                }
                that.replaceCalcId = prj.calculationId;
                setTimeout(() => {
                  that.showReplaceInOfferSelect = true;
                  that.waitDoneOperation = false;
                }, 200);
              }, 200);
            }
          })
          .catch(error => {
            // riabilitazione pulsante PRINT (NEXT)
            that.waitDoneOperation = false;
          });
      } else {
        that.waitDoneOperation = false;
      }
    },
    afterSaveProjectDialogVisible: function(result) {
      var that = this;
      that.saveProjectDialogVisible = false;
      if (result) {
        that.SalvaDatiAccessori().then(function(data) {
          if (data != null) {
            that.UpdateProject(data);
            that.saveProject();
          }
        });
      }
    },
    printProject: function() {
      var that = this;
      var project = that.projects;
      var prj = {};
      for (var el in project) {
        prj = project[el];
      }
      var cId = prj.calculationId;
      var rpt = document.querySelector("#reportPath").value;

      var rpt2 = document.querySelector("#reportPath2").value;
      if (rpt2 == "origin") {
        rpt = window.location.origin + "/UnilabReport/";
      }

      var at = Cookies.get("loginToken");

      var routeData =
        rpt +
        "/ReportViewer/ReportViewerView?at=" +
        at +
        "&calculationId=" +
        cId +
        "&modality=" +
        prj.modality +
        "&language=" +
        store.getters.currentLanguage +
        "&showTransId=" +
        that.$store.getters.bShowTranslationsId;

      window.open(routeData, "_blank");
    },
    resetSubViews() {
      this.preprintViewHidden = true;
      this.warningsViewHidden = true;
    },
    calcModeToggle(mode) {
      //console.log("calcModeToggle > " + mode);
      var that = this;
      var performVerify = false;
      var performDesign = false;
      var performSelection = false;
      if (mode === "verify" || mode === "checking" || mode === 2 || mode === 3) {
        performVerify = true;
        performDesign = false;
        performSelection = false;
      }
      if (mode === "selection" || mode === 1) {
        performVerify = false;
        performDesign = false;
        performSelection = true;
      }
      if (performVerify) {
        performDesign = false;
        performSelection = false;
      }
      this.$store.dispatch("changeProjectProperty", {
        path: that.project.path + ".performDesign",
        value: performDesign
      });
      this.$store.dispatch("changeProjectProperty", {
        path: that.project.path + ".performSelection",
        value: performSelection
      });
    },
    subViewToggle(subView) {
      if (subView === "toggleVerifyViewProperty") {
        /*this.verifyView = true;
        this.designView = false;
        this.selectionView = false;
        this.selectionOutputView = false;*/
        return;
      }
      if (subView === "toggleSelectionViewProperty") {
        /*this.verifyView = false;
        this.designView = false;
        this.selectionView = true;
        this.selectionOutputView = false;*/
        return;
      }
      if (subView === "toggleSelectionOutputViewProperty") {
        /*this.verifyView = false;
        this.designView = false;
        this.selectionView = false;
        this.selectionOutputView = true;*/
        return;
      }
      if (subView === "togglePrePrintViewProperty") {
        this.preprintViewHidden = !this.preprintViewHidden;
        return;
      }
      if (subView === "toggleWarningsViewProperty") {
        this.warningsViewHidden = !this.warningsViewHidden;
        if (!this.warningsViewHidden && (this.bAskToContinue || this.bHasBlockingWarnings)) {
          /*store.dispatch("refreshFormInput");
          store.dispatch("refreshAll");*/
          this.settaValoreDiretto("calculated", this.calculated);
          this.$store.dispatch("ensureStatus", statuses.PRE_CALCOLO);
          this.bAskToContinue = false;
        }
        return;
      }
    },
    //24/09/2020 Marco B WARNING CON MODALE (prova)
    showWarningsModal() {
      this.pannelloWarning = true;
    }
  },
  beforeRouteUpdate: function(to, from, next) {
    next({
      name: "SwitchProject",
      params: {
        modality: to.params.modality,
        projectId: to.params.projectId
      }
    });
    return;
  },
  beforeRouteEnter: function(to, from, next) {
    var that = this;

    if (to.name === "ViewProject") {
      projectService
        .getProject(to.params.modality, to.params.projectId)
        .then(function(data) {
          store.dispatch("loadProject", {
            projectId: data.projectId,
            project: data
          });

          next(vm => vm.initProj(data));
        })
        .catch(function(ex) {
          console.log(ex);
          next(false);
        });
    } else {
      alert("WRONG!!");
    }
  },
  beforeRouteLeave: function(to, from, next) {
    // alert("sono qui");
    let msg = this.uniTranslation("PHE20000");
    MessageBox.confirm(msg)
      .then(() => {
        this.$store.dispatch("changeActiveProjectModalityProperty", 0);
        this.$store.dispatch("clearCurrentProject", this.project.projectId);
        next();
      })
      .catch(() => {
        next(false);
      });
    /*var that = this;
    if (that.saved == false)
    {
      let msg = that.uniTranslation('S1782');
      msg = msg.replaceAll('$1', that.project.name);
      MessageBox.confirm(msg)
        .then(_ => {
          that.saveProject();
        })
        .catch(_ => {
          next(false);
        });
    }
    else
    {
    }
    /*const answer = window.confirm('Do you really want to leave? All unsaved changes will be lost.')
    if (answer) {
      next()
    } else {
      next(false)
    }*/
  }
};
</script>

<style lang="scss">
/*.print-container {
  width: 100%; 
  height: 100%; 

  .iframe {
    border-width: 0px;
    display: flex; 
    width: 100%; 
    height: 900px;
    flex-direction: column;
    flex-grow: 1;
  }
}*/

.project-footer {
  width: 100vw;
  position: fixed; /* relative */
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  height: 50px;
  bottom: 0px;
  background-color: rgba(185, 239, 255, 0.7);
  padding: 5px;

  background-clip: border-box;
  border: 1px solid #c2cfd6;

  transition: all 250ms linear;
  &.open {
    bottom: 50px;
    transition: all 250ms linear;
  }

  /*width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;


  position: fixed; /* absolute fixed* / 
  width: 100%;
  margin-right: auto;
  margin-left: auto;


  overflow: auto;
  float: left;
  display:inline-block;*/
}

.project-footer-inner {
  padding-left: 250px;
}

.customSpinner {
  font-size: 50px;
}

/*.btn-calculate {
  border-radius: 2px;
  //background-color: #1879b9;
  color: white;
  padding: 3px 20px;
  margin-top: 10px;
  margin-right: 15px;
  margin-left: 15px;
  text-transform: uppercase;
}
.btn-save-project {
  border-radius: 2px;
  //background-color: #1879b9;
  color: white;
  padding: 3px 20px;
  margin-top: 10px;
  margin-right: 15px;
  margin-left: 15px;
  text-transform: uppercase;
}
.btn-print-project {
  border-radius: 2px;
  //background-color: #1879b9;
  color: white;
  padding: 3px 20px;
  margin-top: 10px;
  margin-right: 15px;
  margin-left: 15px;
  text-transform: uppercase;
}*/
</style>
